import { useNewBuild } from "../../context/NewBuildContext";

/**
 * 헤더의 「업데이트」 버튼 — 새 버전이 나갔는데 사용자가 모달에서 「나중에 하기」를 고른 뒤에만 선다.
 *
 * 모달(NewBuildModal)을 닫아 버린 사람이 손이 비기 전에 스스로 업데이트할 길이다(손이 비면
 * 어차피 자동으로 넘어간다 — NewBuildContext). 새 버전이 없거나 아직 모달이 떠 있을 때는
 * 아무것도 그리지 않는다(헤더 폭을 안 먹는다).
 * 선택 이용(외부용) 화면에도 그대로 보인다 — 우리 내부 데이터가 아니라 앱을 쓰는 데 필요한
 * 최소한(옛 코드로 계속 쓰면 터진다)이기 때문이다.
 */
export default function NewBuildHeaderButton({ className = "" }: { className?: string }) {
  const { phase, reload } = useNewBuild();
  if (phase !== "deferred") return null;

  return (
    <button
      type="button"
      onClick={reload}
      title="새 버전이 준비됐어요 — 누르면 화면을 새로고침해 반영합니다"
      aria-label="새 버전으로 업데이트"
      className={`relative flex h-9 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg bg-brand-500 px-3 text-xs font-semibold text-white shadow-theme-xs transition hover:bg-brand-600 ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4"
      >
        <path d="M21 12a9 9 0 1 1-3-6.7" />
        <path d="M21 3v6h-6" />
      </svg>
      업데이트
      <span className="absolute -right-1 -top-1 flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-orange-500 ring-2 ring-white dark:ring-gray-900" />
      </span>
    </button>
  );
}
